import DatePicker from "react-datepicker";
import { FC, useEffect, useState } from "react";
import DatePickerCustomHeaderTwoMonth from "components/DatePickerCustomHeaderTwoMonth";
import DatePickerCustomDay from "components/DatePickerCustomDay";
import { weekdays } from "utils/weekdays";
import { useHotels } from "contexts/HotelsSearchContext/HotelProvider";
import { useMetadataUser } from "contexts/metadata-user-context";
import { Formatter } from "utils/formatters";

export interface StayDatesRangeInputProps {
  className?: string;
}

const StayDatesRangeInput: FC<StayDatesRangeInputProps> = ({
  className = "",
}) => {
  const [startDate, setStartDate] = useState<Date | null>();
  const [endDate, setEndDate] = useState<Date | null>();
  const [, setIsOpen] = useState(false);
  const { profile } = useMetadataUser();
  const { 
    setCheckInDate, 
    setNumNights, 
    checkInDate,
    numNights,
    showHeroSearch,
    setShowHeroSearch,
  } = useHotels();

  useEffect(() => {
    if (checkInDate && numNights) {
      const checkinWithTimezone = checkInDate + 'T00:00:00-03:00';
      const checkInDateTypeDate = new Date(checkinWithTimezone);
      const checkoutDate = new Date(`${checkInDate}T00:00:00-03:00`);
      checkoutDate.setDate(checkInDateTypeDate.getDate() + numNights);
      if (profile?.subscription?.active && profile?.subscription?.blocked_until && !profile?.company) {
        if (checkoutDate < new Date(profile.subscription.blocked_until)) {
          const newCheckinDate = new Date(profile.subscription.blocked_until);
          newCheckinDate.setDate(newCheckinDate.getDate() + 2);
          setStartDate(newCheckinDate);

          const newCheckoutDate = new Date(newCheckinDate);
          newCheckoutDate.setDate(newCheckoutDate.getDate() + numNights);

          setEndDate(newCheckoutDate);
          setCheckInDate(Formatter.prettyDateHifen(newCheckinDate));
          return;
        }
      }
      setStartDate(checkInDateTypeDate);
      setEndDate(checkoutDate);
    }

    if (showHeroSearch === "dates") {
      setIsOpen(true);
    }
  }, [showHeroSearch]);

  const onChangeDate = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    if (start && end && end !== endDate) {
      const startDateFormated = Formatter.prettyDateHifen(start);
      const rangeInMilliseconds = end.getTime() - start.getTime();
      const rangeInDays = rangeInMilliseconds / (1000 * 60 * 60 * 24);
      setCheckInDate(startDateFormated);
      setNumNights(rangeInDays);
      setShowHeroSearch("guests");
      setIsOpen(false);
    }
    setStartDate(start);
    setEndDate(end);
  };

  const dateBlocked = (date: Date): Date => {
    if (profile?.subscription?.active && profile?.subscription?.blocked_until && !profile?.company) {
      if (date < new Date(profile.subscription.blocked_until)) {
        const newDate = new Date(profile.subscription.blocked_until);
        newDate.setDate(newDate.getDate() + 2);
        return newDate;
      }
    }
    return date;
  }

  return (
    <div>
      <div className="p-5">
        <span className="block font-semibold text-xl sm:text-2xl">
          {`Quando é a sua viagem?`}
        </span>
      </div>
      <div
        className={`relative flex-shrink-0 flex justify-center z-10 py-5 ${className} `}
      >
        <DatePicker
          formatWeekDay={(nameOfDay) =>
            weekdays[weekdays.findIndex((day) => day.enUS === nameOfDay)].ptBR
          }
          selected={startDate}
          onChange={onChangeDate}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          monthsShown={2}
          minDate={dateBlocked(new Date())}
          showPopperArrow={false}
          inline
          renderCustomHeader={(p) => <DatePickerCustomHeaderTwoMonth {...p} />}
          renderDayContents={(day, date) => (
            <DatePickerCustomDay dayOfMonth={day} date={date} />
          )}
        />
      </div>
    </div>
  );
};

export default StayDatesRangeInput;
